module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAGQCAYAAABvWArbAAAAPklEQVQ4je3PMQqAMABD0Z/c/7aCIAXjJIhD10LJ8vgZw30eMUApZV/GhZNgSTjoLYElY/hNMJ/S6gullCkPiCIPCr4NiEwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/main/javascript/modules/react-components/css/wrapper/images/ui-bg_glass_95_fef1ec_1x400.png
// module id = 479
// module chunks = 0